import { createElement } from '@max/max';
import View from '@hfe/max-view';
import { LIST_STATUS, SHOW_TYPE } from './types';
import ScrollView from '@hfe/max-scrollview';
import { toPx } from '@max/leez-style-util';
import './index.scss';
import Skeleton from '@hfe/max-skeleton';
import { skData } from './sk.js';
import Sensor from '@max/mbc-sensor';
import { LoadingMore } from './loading-more';
const NoMoreImageConfig = {
    uri: 'https://p0.meituan.net/ingee/4389c4e1268e625401921d052189d50b8549.png',
    width: toPx(126 / 2),
    height: toPx(27 / 2)
};
function ListContainer(props) {
    var _a, _b, _c;
    const { vo, feConfig, listStatus, loadMoreStatus, loadMoreType, onCardShow, onCardClick, isLastPage, onLoadMore, onContainerShow, showType, ChildComponent, listContainerStyle, styleOptions } = props;
    const containerStyle = listContainerStyle !== null && listContainerStyle !== void 0 ? listContainerStyle : {};
    if (showType === SHOW_TYPE.HORIZONTAL) {
        containerStyle.height = '580rpx';
    }
    return <Sensor className="list-container" style={Object.assign({}, containerStyle)} onAppear={() => {
            onContainerShow();
        }} once>
      {/* <InvalidState x-if={listStatus === LIST_STATUS.ERROR} onPress={props.onRetry} /> */}
      <View x-if={listStatus === LIST_STATUS.LOADING && showType === SHOW_TYPE.VERTICAL_DOUBLE} className="list-container--loading">
        <Skeleton height={'1700rpx'} width={'750rpx'} data={skData}/>
      </View>
      <View x-if={listStatus === LIST_STATUS.SUCCESS && ((_a = vo === null || vo === void 0 ? void 0 : vo.list) === null || _a === void 0 ? void 0 : _a.length) > 0} className="list-container--success">
        <View x-if={showType === SHOW_TYPE.VERTICAL_DOUBLE} className="list-container--success-vertical">
          {(_b = vo === null || vo === void 0 ? void 0 : vo.list) === null || _b === void 0 ? void 0 : _b.map((voItem, index) => <View className="list-container__item--vertical" key={voItem.id}>
              <ChildComponent key={voItem.id} vo={voItem} feConfig={feConfig} index={index} onCardClick={onCardClick} onCardShow={onCardShow}/>
            </View>)}
          <LoadingMore loadMoreStatus={loadMoreStatus} loadMoreType={loadMoreType} onLoadMore={onLoadMore} showType={showType} isLastPage={isLastPage} loadMoreTextColor={styleOptions.loadMoreTextColor}/>
        </View>
        <View x-if={showType === SHOW_TYPE.HORIZONTAL} className="list-container--success-horizontal">
          <ScrollView horizontal={true} showsHorizontalScrollIndicator={false} className="list-container--success-horizontal-scroll">
            {(_c = vo === null || vo === void 0 ? void 0 : vo.list) === null || _c === void 0 ? void 0 : _c.map((voItem, index) => <View className="list-container__item--horizontal" key={voItem.id}>
                <ChildComponent key={voItem.id} vo={voItem} feConfig={feConfig} index={index} onCardClick={onCardClick} onCardShow={onCardShow}/>
              </View>)}
            <LoadingMore loadMoreTextColor={styleOptions.loadMoreTextColor} loadMoreStatus={loadMoreStatus} loadMoreType={loadMoreType} onLoadMore={onLoadMore} showType={showType} isLastPage={isLastPage}/>
            <View></View>
          </ScrollView>
        </View>
      </View>
    </Sensor>;
}
export default ListContainer;
